import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "src/app/services/auth/auth.service";
import { PedidoConsultaInternaOutput } from "src/app/@shared/models/consulta-detalhes-interno";
import { AbaRemetentesDestinatariosComponent } from "./components/aba-remetentes-destinatarios/aba-remetentes-destinatarios.component";
import { AbaDadosGuiaComponent } from "./components/aba-dados-guia/aba-dados-guia.component";
import { AbaHistoricoRastreamentoComponent } from "./components/aba-historico-rastreamento/aba-historico-rastreamento.component";
import { AbaRatComponent } from "./components/aba-rat/aba-rat.component";
import { AbaComprovanteComponent } from "./components/aba-comprovante/aba-comprovante.component";
import { AbaPesoNrtComponent } from "./components/aba-peso-nrt/aba-peso-nrt.component";
import { AbaFotoDaEntragaComponent } from "./components/aba-foto-da-entrega/aba-foto-da-entrega.component";
import { AbaReentregaComponent } from "./components/aba-reentrega/aba-reentrega.component";
import { AbaImpressaoConsultaInternaComponent } from "./components/aba-impressao/aba-impressao.component";

@Component({
  selector: "app-bloco-detalhes-internos",
  templateUrl: "./bloco-detalhes-internos.component.html",
  styleUrls: ["./bloco-detalhes-internos.component.scss"],
})

export class BlocoDetalhesInternosComponent implements OnInit, AfterViewChecked {
  @Input('pedido') pedido: PedidoConsultaInternaOutput;
  @Input() parent: BlocoDetalhesInternosComponent;

  isLoading: boolean = false;
  btnNextPrev = {
    prev: true,
    next: true,
    index: 0,
  };
  itensMenu: any = [];

  public rota = "relatorios.tracking.consulta-pedido-detalhes-interna";

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: PedidoConsultaInternaOutput,
    public authService: AuthService,
    private cdr: ChangeDetectorRef,
    public snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {
    this.pedido = data ?? this.pedido;
  }

  public formCadastro: FormGroup = new FormGroup({});
  configsTela = {};

  ngOnInit() {
    this.loadConfigsTela(); this.loadMenu();
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  loadConfigsTela() {
    var componentes = [
      AbaRemetentesDestinatariosComponent,
      AbaDadosGuiaComponent,
      AbaPesoNrtComponent,
      AbaReentregaComponent,
      AbaHistoricoRastreamentoComponent,
      AbaRatComponent,
      AbaComprovanteComponent,
      AbaFotoDaEntragaComponent,
      AbaImpressaoConsultaInternaComponent
    ];
    this.configsTela['root'] = componentes;
  }

  public loadMenu() {
    this.itensMenu = {
      etapaAtual: 1,
      menu: this.getMenu(),
    };
  }

  getMenu() {
    let menu = [];
    let configs = this.configsTela['root'];
    for (let etapa = 0; etapa < configs.length; etapa++) {
      const item = configs[etapa];
      menu.push({
        etapa: etapa + 1,
        label: item.Title,
        component: item,
        inputs: {
          parent: this,
          pedido: this.pedido,
        },
        outputs: {},
        obrigatorio: true,
        concluido: item.Concluido,
      });
    }
    return menu;
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  tooltipHelp(campo) {
    return `${campo}#${this.rota}`;
  }
}
